import React from 'react';
import styled, { StylesProps } from '../../../../../lib/styles';
import travelHolidayBlock_styles from './TravelHolidayBlock_styles';
import { compose } from 'recompose';
import Spacer from '../../../../../components/presentational/Spacer';
import HolidaysBlock from '../../../../../components/presentational/HolidaysBlock';
import { fetchMoreHolidays } from '../../../../TravelCollection/TravelCollection';
import { trackEvent } from '../../../../../lib/ga';
import { SHOW_MORE_HOLIDAYS, SHOW_MORE_PAGINATED_HOLIDAYS } from '../../../../TravelCollection/lib/ga';
import { Holiday } from '../../../../../models/holiday';
import { Ad as AdData } from '../../../../../../src/components/presentational/Ad';
import theme from '../../../../../lib/theme';
const { mediaSizes } = theme;

interface HolidayBlockData {
  title: string;
  subtitle: string;
  description: string;
  feature: boolean;
  linkText: string;
  backfillOption: string;
  backfillValue: string;
  backfillExcludes: [];
  backfillCursor: number;
  pagination: boolean;
  linkURL: string;
  hideAds: boolean;
  holidays: Holiday[];
}

export interface TravelHolidayBlockData extends HolidayBlockData {
  type: 'travel_holiday_block';
}

export interface SuggestedHolidayBlockData extends HolidayBlockData {
  type: 'suggested_holiday_block';
}

export interface TravelHolidayBlockProps {
  block: TravelHolidayBlockData;
  collectionConfig: {
    ads: AdData,
    loadMoreGroupHolidays,
  }
}

export const TravelHolidayBlock = ({
  block,
  block: { 
    title,
    subtitle,
    description,
    feature,
    linkText,
    backfillOption,
    backfillCursor,
    pagination,
    linkURL,
    holidays,
  },
  collectionConfig: {
    loadMoreGroupHolidays,
  },
  styles 
}: TravelHolidayBlockProps & StylesProps<typeof travelHolidayBlock_styles>) => {
  return (
    <div className={`travel-holiday-block v2-collection-block ${styles.container}`}>
      <Spacer maxWidth={mediaSizes.xxl ?? '1200px'} space={['m', 'l']}>
        <HolidaysBlock
          key={title}
          feature={feature}
          holidays={holidays}
          title={title}
          subtitle={subtitle}
          description={description}
          topAd={undefined}
          hasMore={
            (pagination === false &&
              !!linkText &&
              !!linkURL) ||
            (pagination === true &&
              backfillOption !== 'none' &&
              backfillCursor !== -1)
          }
          lazy={false}
          showMoreText={
            linkText
              ? linkText
              : 'Show more holidays'
          }
          onShowMore={() => {
            if (pagination) {
              fetchMoreHolidays(0, loadMoreGroupHolidays, block);
              trackEvent(SHOW_MORE_PAGINATED_HOLIDAYS, {
                transport: 'beacon',
              });
            } else {
              window.open(linkURL, '_blank');
              trackEvent(SHOW_MORE_HOLIDAYS, {
                transport: 'beacon',
              });
            }
          }}
        />
      </Spacer>
    </div>
  );
};

export default compose(styled(travelHolidayBlock_styles))(TravelHolidayBlock);